export enum Role {
    Guest = 'guest',
    Mover = 'mover',
    RealEstateAgent = 'realEstateAgent',
    Admin = 'admin',
    Client = 'client',
    PartnerAgent = 'partnerAgent',
}
